__turbopack_context__.v({
  "lastUpdated": "styles-module-scss-module__IN7CjW__lastUpdated",
});
